// The agent's default "no encontré esa información" reply — ONE definition,
// read by both the runtime that sends it and the Ajustes form that previews it.
//
// It used to live only in the engine (`process-inbound.ts`), so the web form's
// placeholder was a hand-typed approximation that had already drifted: the
// helper text promised "Vacío = mensaje por defecto" while showing a default
// the agent never actually says. A placeholder that lies about the default is
// the same painted door as an action label with no destination.
//
// Exported via the `@vysto/shared/bot-config/deferral` subpath (a FILE, like
// `identity.ts`) so the web imports it without pulling the package barrel —
// the barrel drags jsonwebtoken/pino into the browser bundle.

/** Honest deferral the orchestrator's `answer` node sends when the knowledge
 *  base has nothing relevant — instead of letting the model improvise from its
 *  own general knowledge (off-brand + can invent facts the business never said).
 *  Offers a person or a rephrase, and the flow continues (the loop lets the
 *  customer then ask for an Asesor). Product call with Juan 2026-06-25.
 *
 *  Overridden per bot by `conocimiento.no_match_message`. */
export const DEFAULT_KB_DEFERRAL =
  'Por ahora no tengo esa información para responderte con certeza. ¿Quieres que te comunique con una persona del equipo, o prefieres que lo intentemos de otra forma?'
